import { map } from "rxjs";
import { UseEntityStore } from "./entityStore";
import { DataFilter, FilterItemOperator, UseListStore } from "./listStore";
import { isoDateFormat } from "./utils";
import { dayjs } from "./config";

export interface Filter<T, F> {
    filterProp: keyof F;
    listProps: (keyof T)[];
    operator: keyof typeof FilterItemOperator;
    transform?: (value: any) => any;
    fullText?: boolean;
}

export function applyListStoreFilters<T, F>(useFiltersStore: UseEntityStore<F>, useListStore: UseListStore<T>, filters: Filter<T, F>[], searchOnChange = false) {
    return useFiltersStore.getState().clientData$.pipe(map(p => p.data)).subscribe({
        next(data) {
            const dataFilters: DataFilter<T>[] = filters.map(p => ({
                operator: p.operator,
                props: p.listProps,
                value: (p.transform || (x => x))(data[p.filterProp] as any),
                fullText: p.fullText,
            })).filter(p => p.value != null && p.value !== "");
            useListStore.getState().setExternalDataFilters(dataFilters);
            if (searchOnChange) {
                useListStore.getState().fetch({ updateFetchFilterData: true, forceFetch: useListStore.getState().config.supportsApiFilterSortPage ? undefined : false });
            }
        }
    });
}

export function nextDay(p: string | null | undefined) {
    return p && dayjs.tz(p).add(1, "day").format(isoDateFormat);
}
